



























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CartDetailedFooter extends Vue {
  @Prop() private subTotal!: string;

  @Prop() private tax!: string;

  @Prop() private tip!: string;

  @Prop() private rewardValue!: string;

  @Prop() private totalPrice!: string;
}
